import { render, staticRenderFns } from "./CreateInvoice.vue?vue&type=template&id=504dfa58&scoped=true"
import script from "./CreateInvoice.vue?vue&type=script&lang=js"
export * from "./CreateInvoice.vue?vue&type=script&lang=js"
import style0 from "./CreateInvoice.vue?vue&type=style&index=0&id=504dfa58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504dfa58",
  null
  
)

export default component.exports